const extend = require('lodash/extend');

function CancelReasonFactory($translate) {
  return class CancelReason {
    constructor(input = {}) {
      extend(this, input);
    }

    get details() {
      return this.isOther ? this.userDetails : this.localeDetails;
    }

    get code() {
      return this.cancelReason;
    }

    get isOther() {
      return this.code === 1;
    }

    get localeDetails() {
      return this.cancelReasonText || $translate.instant(`CANCEL_REASON_${this.code}`);
    }
  };
}

CancelReasonFactory.$inject = ['$translate'];

module.exports = angular.module('msi.subscriptions.CancelReason', ['pascalprecht.translate'])
  .factory('CancelReason', CancelReasonFactory).name;
